import { USD_DECIMALS } from '@ui/constants/numbersDecimals';
import { GenericTradeParams, TpSlValueState } from '@ui/features/Trade/types';
import { toBigValue } from '@ui/lib/bignumber';
import { isEmpty, isNil } from 'lodash-es';
import { useMemo } from 'react';

export const useUpdateOrderTpAndSlParams = ({
  // will be diff after MVP
  genericTradeParams,
  tp,
  sl,
}: {
  tp: TpSlValueState;
  sl: TpSlValueState;
} & GenericTradeParams):
  | readonly [`0x${string}`, bigint, bigint]
  | undefined => {
  return useMemo(() => {
    if (isNil(tp.priceValue) || isEmpty(tp.priceValue)) return undefined;

    const tpPriceValue = tp.priceValue;
    const slPriceValue = sl.priceValue;

    return [
      genericTradeParams.id,
      isNaN(parseFloat(tpPriceValue))
        ? 0n
        : toBigValue(tpPriceValue, USD_DECIMALS),
      isNaN(parseFloat(slPriceValue))
        ? 0n
        : toBigValue(slPriceValue, USD_DECIMALS),
    ] as const;
  }, [genericTradeParams.id, sl.priceValue, tp.priceValue]);
};
